'use client'

import {
  SharedFooter,
  type SharedFooterData,
} from '@b-stock/fe-core/bstock-react'

import { PageWidth } from './PageWidth'

/**
 * `data` is fetched in the root layout, which also evaluates the flag gating it — so `undefined`
 * here means either the flag is off or the CMS had nothing to give, and fe-core renders its
 * bundled links either way. Nothing about the CMS is decided in this component.
 */
const Footer = ({ data }: { data?: SharedFooterData }) => {
  return (
    <PageWidth data-gtm-event-position="footer">
      <SharedFooter data={data} />
    </PageWidth>
  )
}

export default Footer
